import { Singleton } from '@denishussar/html5-game-engine';

export enum ExchangeMoneyEnum {
    empty = 'empty',
    rub = 'rub',
    usd = 'usd',
    eur = 'eur',
    jpy = 'jpy',
    button = 'button',
}

export enum ExchangeStateEnum {
    open = 'open',
    close = 'close',
}

@Singleton
export class ExchangeModel {
    public money: ExchangeMoneyEnum = ExchangeMoneyEnum.rub;
    public state: ExchangeStateEnum = ExchangeStateEnum.close;

    constructor() {

    }
}
